module.exports = __webpack_public_path__ + "static/media/Group 237788.a2587a22.webp";